import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';
import { ReactComponent as WarningIcon } from 'applicaiton/assets/unsuccess-icon.svg';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { resetIsEndedAppointmentError } from 'applicaiton/store/reducers/Appointments/AppoinmentsSlice';
import { EndAppointmentErrors } from 'applicaiton/constants/endAppointmentErrors';

const EndAppointmentError: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isEndedAppointmentError } = useAppSelector(
    (state) => state.appointmentsSlice,
  );

  const handleClose = () => {
    dispatch(resetIsEndedAppointmentError());
  };

  const getCurrentErrorText = () => {
    switch (isEndedAppointmentError) {
      case EndAppointmentErrors.APPOINTMENT_NOT_FOUND:
        return t('end_appointment_errors.appointment_not_found');
      case EndAppointmentErrors.APPOINTMENT_HAS_NO_PAYMENT:
        return t('end_appointment_errors.payment_not_done');
      case EndAppointmentErrors.INVOICE_CREATION_FAILED:
        return t('end_appointment_errors.error_invoice_creation');
      case EndAppointmentErrors.BILLING_API_KEY_NOT_FOUND:
        return t('end_appointment_errors.fact_api_error');
      case EndAppointmentErrors.INTERNAL_SERVER_ERROR:
        return t('end_appointment_errors.error');

      default:
        return t('end_appointment_errors.error');
    }
  };

  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={handleClose} />
        <div>
          <WarningIcon />
          <p>{getCurrentErrorText()}</p>
          <SecondaryButton onClick={handleClose}>
            {t('appointment_types.modal_success.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default EndAppointmentError;
